"use strict";

exports.__esModule = true;
exports.LogbookItemDescription = LogbookItemDescription;
var _react = _interopRequireDefault(require("react"));
var _Time = require("../../Time");
var _EditTicketComment = require("../../Ticketing/TicketDetails/EditTicketComment");
var _styles = require("./styles");
var _TicketCommentActionButtons = require("../../Ticketing/TicketDetails/TicketCommentActionButtons");
var _core = require("@blueprintjs/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var isCommentEdited = function isCommentEdited(ticketComment) {
  var _ticketComment$commen;
  return ticketComment == null || (_ticketComment$commen = ticketComment.comment) == null ? void 0 : _ticketComment$commen.isEdited;
};
var showCommentIcons = function showCommentIcons(ticketComment) {
  return !ticketComment.isEditing && ticketComment.isAuthorized;
};
function LogbookItemDescription(props) {
  var time = _react["default"].useContext(_Time.TimeContext);
  var title = props.title,
    creator = props.creator,
    created = props.created,
    id = props.id,
    ticketComment = props.ticketComment,
    editedTimestamp = props.editedTimestamp;
  return /*#__PURE__*/_react["default"].createElement(_styles.DescriptionWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.UserWrapper, {
    "data-testid": "TicketCommentUsername"
  }, creator), /*#__PURE__*/_react["default"].createElement(_styles.DateWrapper, {
    "data-testid": "FormattedPlantDate",
    style: {
      paddingTop: "1px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    position: "top-left",
    content: "Edited at: " + new Date(editedTimestamp).toLocaleString(time.timezone.locale, {
      timeZone: time.timezone.name
    }),
    minimal: true,
    disabled: !editedTimestamp
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Time.FormattedPlantDate, {
    formatOptions: {
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    },
    value: created
  }), editedTimestamp && " (edited)"))), isCommentEdited(ticketComment) && /*#__PURE__*/_react["default"].createElement(_styles.EditedLabel, {
    "data-testid": "EditedLabel"
  }, "(edited)"), id && /*#__PURE__*/_react["default"].createElement(_styles.IdNumber, {
    "data-testid": "TicketId"
  }, "#" + id), ticketComment && showCommentIcons(ticketComment) && /*#__PURE__*/_react["default"].createElement(_TicketCommentActionButtons.TicketCommentActionButtons, {
    ticketComment: ticketComment
  }), /*#__PURE__*/_react["default"].createElement(_styles.Body, {
    "data-testid": "TicketCommentTitle",
    style: {
      marginLeft: ticketComment != null && ticketComment.isEditing ? "-5px" : "0px"
    }
  }, ticketComment && ticketComment != null && ticketComment.isEditing ? /*#__PURE__*/_react["default"].createElement(_EditTicketComment.EditTicketComment, {
    ticketComment: ticketComment
  }) : title));
}